import { render, staticRenderFns } from "./displayLabel.vue?vue&type=template&id=556e8359&scoped=true&"
import script from "./displayLabel.vue?vue&type=script&lang=js&"
export * from "./displayLabel.vue?vue&type=script&lang=js&"
import style0 from "./displayLabel.vue?vue&type=style&index=0&id=556e8359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e8359",
  null
  
)

export default component.exports